const doc = [({"en":({"constantBookingErrorCode":({"no_data":"Could not retrieve booking data.", "unknown":"Unknown error occurred."})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;